<template>
  <div>
    <el-dialog
      width="720px"
      :visible="show"
      class="visa-fee-recharge-dialog"
      :title="$t('financial.dialog.visaFeeOnlineRecharge')"
      @close="handleClose"
    >
      <section class="visa-fee-recharge-dialog__content">
        <div class="visa-fee-recharge-dialog__step">
          <p class="visa-fee-recharge-dialog__step-name">{{ $t('financial.dialog.step1') }}</p>
          <h3 class="visa-fee-recharge-dialog__step-title">{{ $t('financial.dialog.alipayScan') }}</h3>
          <img
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/visa-fee-recharge-step-1.png"
            :alt="$t('financial.dialog.alipayScanAlt')"
            class="visa-fee-recharge-dialog__step-image"
          />
          <p class="visa-fee-recharge-dialog__step-tips">{{ $t('financial.dialog.scanPayHint') }}</p>
        </div>

        <div class="visa-fee-recharge-dialog__step">
          <p class="visa-fee-recharge-dialog__step-name">{{ $t('financial.dialog.step2') }}</p>
          <h3 class="visa-fee-recharge-dialog__step-title">{{ $t('financial.dialog.fillRemark') }}</h3>
          <template v-if="channel === 'lyb'">
            <img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/visa-fee-recharge-step-2_lyb.png"
              :alt="$t('financial.dialog.fillRemarkAlt')"
              class="visa-fee-recharge-dialog__step-image"
            />
            <p class="visa-fee-recharge-dialog__step-tips">{{ $t('financial.dialog.remarkHintLyb') }}</p>
          </template>
          <template v-else>
            <img
              src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/visa-fee-recharge-step-2.png"
              :alt="$t('financial.dialog.fillRemarkAlt')"
              class="visa-fee-recharge-dialog__step-image"
            />
            <p class="visa-fee-recharge-dialog__step-tips">{{ $t('financial.dialog.remarkHintDefault') }}</p>
          </template>
        </div>

        <div class="visa-fee-recharge-dialog__step">
          <p class="visa-fee-recharge-dialog__step-name">{{ $t('financial.dialog.step3') }}</p>
          <h3 class="visa-fee-recharge-dialog__step-title">{{ $t('financial.dialog.autoCredit') }}</h3>
          <img
            src="https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/visa-fee-recharge-step-3.png"
            :alt="$t('financial.dialog.autoCreditAlt')"
            class="visa-fee-recharge-dialog__step-image"
          />
          <p class="visa-fee-recharge-dialog__step-tips">{{ $t('financial.dialog.autoCreditHint') }}</p>
        </div>
      </section>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('financial.payment.cancelPay') }}</el-button>
        <el-button
          type="primary"
          class="button-blue"
          @click="recharge"
          :loading="rechargeLoading"
          >{{ $t('financial.payment.scanToPay') }}</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      width="350px"
      :close-on-click-modal="false"
      class="visa-fee-recharge-confirm-dialog"
      :visible.sync="showPayDialog"
      :title="$t('financial.payment.scanPay')"
    >
      <img :src="rechargeInfo.qrCodeUrl" :alt="$t('financial.payment.scanPay')" width="350px" />
      <div style="margin-top: 24px; text-align: center">
        <el-button
          size="large"
          type="primary"
          class="button-blue"
          @click="confirmRecharge"
          :loading="finishLoading"
          >{{ $t('financial.payment.confirmPaid') }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as financialApi from '@/apis/financial'
import { getCookie } from '@/utils/util'

export default {
  name: 'visaFeeRechargeDialog',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    accountType: {
      type: String,
      default: '',
      required: true,
    },
  },
  data() {
    return {
      rechargeLoading: false,
      finishLoading: false,
      showPayDialog: false,
      rechargeInfo: {},
      channel: '',
    }
  },
  watch: {
    show(val, oldVal) {
      if (val && !oldVal) {
        const { userInfo } = getCookie()
        if (userInfo) {
          this.channel = userInfo.channel
        }
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('update:show', false)
    },
    recharge() {
      this.rechargeLoading = true
      financialApi
        .visaFeeRecharge({
          accountType: this.accountType,
        })
        .then((res) => {
          this.rechargeLoading = false
          if (res) {
            if (res.qrCodeUrl) {
              this.rechargeInfo = res
              this.handleClose()
              this.showPayDialog = true
            } else {
              this.$message.warning(this.$t('financial.payment.noScanInfo'))
            }
          }
        })
        .catch((err) => {
          this.rechargeLoading = false
          throw new Error(err)
        })
    },
    confirmRecharge() {
      this.finishLoading = true
      financialApi
        .finishVisaFeeRecharge({
          accountType: this.accountType,
        })
        .then((res) => {
          this.finishLoading = false
          this.showPayDialog = false
        })
        .catch((err) => {
          this.finishLoading = false
          throw new Error(err)
        })
    },
  },
}
</script>

<style lang="scss">
.visa-fee-recharge-dialog {
  &__content {
    display: flex;
    justify-content: space-between;
  }
  &__step {
    width: 200px;
    &-name {
      margin-bottom: 3px;
      font-size: 14px;
      color: $color-black-54;
    }
    &-title {
      margin-bottom: 20px;
      font-size: 21px;
      font-weight: 500;
      color: $color-black-87;
    }
    &-image {
      width: 178px;
      min-height: 178px;
      height: auto;
    }
    &-tips {
      margin-top: 16px;
      font-size: 14px;
      color: $color-black-87;
      line-height: 23px;
      .is-important {
        font-size: 14px;
        font-weight: 500;
        color: $color-yellow;
      }
    }
  }
}
.visa-fee-recharge-confirm-dialog {
  .el-dialog__body {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
